import { render, staticRenderFns } from "./cartItem.vue?vue&type=template&id=e4d4b7ac&scoped=true"
import script from "./cartItem.vue?vue&type=script&lang=js"
export * from "./cartItem.vue?vue&type=script&lang=js"
import style0 from "./cartItem.vue?vue&type=style&index=0&id=e4d4b7ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d4b7ac",
  null
  
)

export default component.exports